
import Vue from 'vue'
import { mixins } from 'cms3-shop-module-ts'
import RecursiveComponent from '~/components/recursive-component/index.vue'

export default Vue.extend({
  name: 'IndexPage',
  components: {
    RecursiveComponent
  },
  mixins: [mixins.statics],
  computed: {
    breadcrumbs () {
      let currentPageStaticDataInstance = this.$static.staticTree?.find((node: { code: string }) => node.code === 'index')
      if (!currentPageStaticDataInstance) { return currentPageStaticDataInstance }

      const pagePath: string[] = this.codePage?.split('.')
      pagePath.shift()

      const breadcrumbs: { title: string, href: string }[] = []

      let linkCode = ''

      pagePath.forEach((code) => {
        currentPageStaticDataInstance = currentPageStaticDataInstance?.children?.find(child => child.code === code)
        linkCode += `/${currentPageStaticDataInstance?.code}`
        if (!currentPageStaticDataInstance) { return }
        breadcrumbs.push({ title: currentPageStaticDataInstance?.title, href: linkCode })
      })

      return breadcrumbs
    }
  }
})
